// extracted by mini-css-extract-plugin
export default {"header":"tariffs_header__p04OV"};